import styled from "styled-components"

export const SelectInput = styled.select`
  width: 11.5vw;
  height: 4.3vh;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 2vw;
  padding-left: 1vw;
  padding-right: 1vw;
  cursor: pointer;

  -webkit-appearance: none;
  appearance: none;

  :focus {
    outline: 0;
  }
`

export const SelectOption = styled.option`
  background-color: #EBEBEB;
  border: 0;
  margin-top: 0.8vh;
  padding-left: 1vw;
  padding-right: 1vw;
`

export const EditRowButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #64748b;
  cursor: pointer;
  padding: 0.3rem;
  transition: background 0.15s, color 0.15s;

  :hover {
    background: #f1f5f9;
    color: #2563eb;
  }
`